export default {
  RUB: '₽',
  USD: '$',
};
